var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["gfu-balloon", _vm.classNames] },
    [
      _vm.hasHeader
        ? _c(
            "div",
            { staticClass: "gfu-balloon__header" },
            [_vm._t("header")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.hasContent
        ? _c(
            "div",
            { staticClass: "gfu-balloon__content" },
            [_vm._t("content")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasActions
        ? _c(
            "div",
            { staticClass: "gfu-balloon__actions" },
            [_vm._t("actions")],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }